import { observer } from 'mobx-react'
import React, { memo } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import PageTitle from '../../components/PageTitle'
import DashboardLayout from '../../layouts/DashboardLayout'

const BiPage = props => {
  const linkBi =
    'https://app.powerbi.com/view?r=eyJrIjoiMzE0NWVlNTktOTM4YS00NDQ5LTgwNzItYjY3M2RmYTZlZTVmIiwidCI6Ijc3M2UyNTU5LTlkMGEtNDBmYi04NmJiLTM1ZjY1Zjc5ODJkNSIsImMiOjEwfQ%3D%3D'

  return (
    <DashboardLayout>
      <Helmet>
        <title>Quản trị dòng tiền</title>
      </Helmet>
      <PageTitle
        location={props.location}
        title={'BQuản trị dòng tiền'}
        hiddenGoBack
      />
      <ContentBlockWrapper styles={{ height: '100%' }}>
        <iframe
          title="QUẢN TRỊ DÒNG TIỀN"
          width="100%"
          height="800"
          src={linkBi}
          frameBorder={0}
          allowFullScreen={true}
        />
      </ContentBlockWrapper>
    </DashboardLayout>
  )
}

BiPage.propTypes = {}

export default memo(observer(BiPage))
